export default {
    noResults: 'No results found',
    showAll: 'Show all {count}',
    everything: 'All',
    defaultPlaceholder: 'Search everything',
    modulePlaceholder: 'Search {module}'
}
